import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Form, Button } from 'react-bootstrap';
import parseUrl from 'parse-url';
import _split from 'lodash/split';
import _toNumber from 'lodash/toNumber';
import _isNumber from 'lodash/isNumber';
import { withStore } from 'store';
import { Input } from 'components';
import { fetchProductDetails } from 'store/actions/gifts';
import { decodeStorage } from 'functions/storageBase64';
import { SEARS_PRODUCT } from 'constants/storage64';
import styles from './styles.module.scss';


const AddGiftByURL = ({ onSearch, dispatch }) => {
  const [giftUrlValue, setGiftUrlValue] = useState('');
  const handleSubmit = ({ giftUrl }, { setFieldError }) => {
    const onError = () => {
      setFieldError('giftUrl', 'Producto no encontrado');
    };
    const { pathname } = parseUrl(giftUrl);

    const paths = _split(pathname, '/');

    const productId = paths
      .map((path) => _toNumber(path))
      .filter((path) => path)
      .find((path) => _isNumber(path));

    if (productId) {
      const onSuccess = (productDetails) => {
        if (onSearch) onSearch(productDetails);
      };
      dispatch(fetchProductDetails({ productId, onSuccess, onError }));
    } else {
      setFieldError('giftUrl', 'Producto no encontrado');
    }
  };

  const validateURL = (values) => {
    const errors = {};
    if (
      values.giftUrl.length &&
      values.giftUrl.indexOf('sears.com.mx/producto') < 0
    ) {
      errors.giftUrl = 'Producto no encontrado';
    }
    return errors;
  };

  useEffect(() => {
    const savedUrl = decodeStorage(SEARS_PRODUCT);
    const isChangedGiftTable = decodeStorage('isChangedGiftTable');
    if(savedUrl && savedUrl.length && isChangedGiftTable) {
      if(document.getElementById('giftUrl_input')){
        setGiftUrlValue(savedUrl);
        document.getElementById('giftUrl_button').click();
      }
    }
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={{ giftUrl: giftUrlValue }}
      validate={validateURL}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form onSubmit={formikProps.handleSubmit}>
          <div className={styles.AddGiftByURL}>
            <p className={styles.text}>
              Puedes ingresar un producto utilizando su link de{' '}
              <a href="https://sears.com.mx" target="_blank" rel="noreferrer">
                sears.com.mx
              </a>
            </p>
            <Input
              id="giftUrl_input"
              containerClassName="p-0"
              name="giftUrl"
              placeholder="https://www.sears.com.mx/"
            />
            <Button id="giftUrl_button" type="submit" block className="primaryButton">
              Agregar
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default withStore({
  mapStateToProps: (state) => ({
    productDetails: state.gifts.productDetails,
  }),
})(AddGiftByURL);
